import * as utils from './Utils';


export function loadStorefrontProductData(callback) {
  if (!window.OnVoardData || !window.OnVoardData.product || !window.OnVoardData.storefront_api_token) return;

  if (!window.OnVoardData.storefront) window.OnVoardData.storefront = {};
  if (window.OnVoardData.storefront.product) {
    callback(window.OnVoardData.storefront.product);
    return;
  }

  let apiToken = window.OnVoardData.storefront_api_token;
  let variables = {};
  variables['productId'] = parseInt(window.OnVoardData.product.id);

  let query = `
    query productById($productId: Int!) {
      site {
        product(entityId: $productId) {
          entityId
          name
          sku
          upc
          type
          availabilityV2 {
            status
          }
          inventory {
            isInStock
          }
          brand {
            name
          }
          defaultImage {
            urlOriginal
          }
          prices {
            ...PricesFields
          }
          variants {
            edges {
              node {
                ...VariantFields
              }
            }
          }
          categories {
            edges {
              node {
                name
              }
            }
          }
        }
      }
    }

    fragment VariantFields on Variant {
      entityId
      sku
      upc
      defaultImage {
        urlOriginal
      }
      prices {
        ...PricesFields
      }
      inventory {
        isInStock
      }
      options {
        edges {
          node {
            ...ProductOptionFields
          }
        }
      }
    }

    fragment ProductOptionFields on ProductOption {
      entityId
      displayName
      isRequired
      values {
        edges {
          node {
            entityId
            label
          }
        }
      }
    }

    fragment PricesFields on Prices {
      price {
        ...MoneyFields
      }
      basePrice {
        ...MoneyFields
      }
      salePrice {
        ...MoneyFields
      }
      retailPrice {
        ...MoneyFields
      }
      saved {
        ...MoneyFields
      }
      priceRange {
        min {
          ...MoneyFields
        }
        max {
          ...MoneyFields
        }
      }
    }

    fragment MoneyFields on Money {
      value
      currencyCode
    }
  `;

  fetch('/graphql', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${apiToken}`
    },
    body: JSON.stringify({
      query: query,
      variables: variables,
    }),
  })
  .then(res => res.json())
  .then(json => {
    let result = utils.cleanGraphQLResponse(json);
    window.OnVoardData.storefront.product = result.data.site.product;
    callback(window.OnVoardData.storefront.product);
  });
}

export function convertDefaultRate(amount, amountCur='') {
  if (amountCur && amountCur === window.OnVoardData.currency_selector.default_currency_code) return amount;
  let exchange_rate = window.OnVoardData.exchange_rate;
  if (!exchange_rate) return amount;

  amount = parseFloat(amount)/parseFloat(exchange_rate);
  amount = Math.round(amount * 100) / 100; // round to 2 decimal float
  amount = Math.round(amount * 20) / 20; // round off to nearest 5 cents
  return amount;
}

export function convertActiveRate(amount, amountCur='') {
  if (amountCur && amountCur === window.OnVoardData.currency_selector.active_currency_code) return amount;
  let exchange_rate = window.OnVoardData.exchange_rate;
  if (!exchange_rate) return amount;

  amount = parseFloat(amount)*parseFloat(exchange_rate);
  amount = Math.round(amount * 100) / 100; // round to 2 decimal float
  return amount;
}

export function executeWithRates(callback) {
  let currency = window.OnVoardData.currency_selector;
  if (currency.default_currency_code === currency.active_currency_code || window.OnVoardData.exchange_rate) {
    callback();
    return;
  }

  // diff rates, need to load rates first
  fetch('/graphql', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${window.OnVoardData.storefront_api_token}`
    },
    body: JSON.stringify({
      query: `
        query getCurrencyDetails($currencyCode: currencyCode!) {
          site {
            currency(currencyCode: $currencyCode) {
              entityId
              code
              name
              isActive
              exchangeRate
              isTransactional
              display {
                decimalToken
                thousandsToken
                decimalPlaces
              }
            }
          }
        }
      `,
      variables: {
        'currencyCode': currency.active_currency_code
      },
    }),
  })
  .then(res => res.json())
  .then(json => {
    window.OnVoardData['exchange_rate'] = json.data.site.currency.exchangeRate;
    callback();
  });
}

export function extractProductCurrency(product) {
  let withoutTax = product.price.without_tax;
  let withTax = product.price.with_tax;
  if (withoutTax && withoutTax.currency) return withoutTax.currency;
  if (withTax && withTax.currency) return withTax.currency;
  return '';
}

export function extractProductPrice(product) {
  let withoutTax = product.price.without_tax;
  let withTax = product.price.with_tax;
  if (withoutTax) return withoutTax.value;
  if (withTax) return withTax.value;
  return 0;
}

export function extractProductCompareAtPrice(product) {
  let withoutTax = product.price.non_sale_price_without_tax;
  let withTax = product.price.non_sale_price_with_tax;
  if (withoutTax) return withoutTax.value;
  if (withTax) return withTax.value;
  return 0;
}
